import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/postReply',
    name: 'postReply',
    component: () => import(/* webpackChunkName: "postReply" */ '../views/postReply/index.vue')
  },
  {
    path: '/keywordAdminister',
    name: 'keywordAdminister',
    component: () => import(/* webpackChunkName: "postReply" */ '../views/keywordAdminister/index.vue')
  },
  {
    path: '/FBAccount',
    name: 'FBAccount',
    component: () => import(/* webpackChunkName: "postReply" */ '../views/FBAccount/index.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "postReply" */ '../views/privacy/index.vue')
  },
  {
    path: '/show',
    name: 'show',
    component: () => import(/* webpackChunkName: "show" */ '../views/show/index.vue')
  },
  {
    path: '/showlogin',
    name: 'showLogin',
    component: () => import(/* webpackChunkName: "show" */ '../views/show/login.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
